import { MembersFormComponent } from './members-form/members-form.component';
import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { MembersComponent } from './members.component';
import { MembersRoutingModule } from './members-routing.module';
import { MembersDetailComponent } from './members-detail/members-detail.component';

@NgModule({
  declarations: [MembersComponent, MembersFormComponent, MembersDetailComponent],
  imports: [
    SharedModule,
    MembersRoutingModule
  ]
})
export class MembersModule { }
